export const normalizeRole = (role: string | null) =>
  role?.replace(/^ROLE_ROLE_/, "ROLE_") ?? null;